import { render, staticRenderFns } from "./ContractsList.vue?vue&type=template&id=436825a5&scoped=true"
import script from "./ContractsList.vue?vue&type=script&lang=js"
export * from "./ContractsList.vue?vue&type=script&lang=js"
import style0 from "./ContractsList.vue?vue&type=style&index=0&id=436825a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436825a5",
  null
  
)

export default component.exports